/**
 * @function getGeneralImage - Method for filtering array of images from strapi
 * @param {object} root0  - destructured object
 * @param {Array} root0.generalImageArray - array of object from strapi
 * @param {string} root0.key - key of the image needs to be fetched from strapi
 * @param {string} root0.view - pass the view of that image to get url and path
 * @returns {object} - returns the object of response
 */
const getGeneralImage = ({ generalImageArray, key, view }) => {
    let imagePath = { url: '', alt: '' };
    const imageArrayForKey = generalImageArray?.filter(obj => obj.Key === key);

    if (imageArrayForKey?.length > 0) {
        if (view === 'DesktopViewImage') {
            imagePath = {
                url: `${window.origin}${imageArrayForKey[0]?.DesktopViewImage?.data?.attributes?.url}`,
                alt: imageArrayForKey[0]?.DesktopViewImage?.data?.attributes?.alternativeText,
            };
        } else if (view === 'MobileViewImage') {
            imagePath = {
                url: `${window.origin}${imageArrayForKey[0]?.MobileViewImage?.data?.attributes?.url}`,
                alt: imageArrayForKey[0]?.MobileViewImage?.data?.attributes?.alternativeText,
            };
        } else if (view === 'TabletViewImage') {
            imagePath = {
                url: `${window.origin}${imageArrayForKey[0]?.TabletViewImage?.data?.attributes?.url}`,
                alt: imageArrayForKey[0]?.TabletViewImage?.data?.attributes?.alternativeText,
            };
        }
    }
    return imagePath;
};

export default getGeneralImage;
